module.exports = (__webpack_require__(4))(1712);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-router/es/MemoryRouter.js from dll-reference vendorProd_library
// module id = 637
// module chunks = 42